import '../components/resources.css';

export function Resources() {
    return (
        <>
        <div>
            <h1 className="resource-title lato-font">Resources</h1>
            <div className='max-width-resource'>
            <div>
                <div className='item1-resource single-resource lato-font'>
                    <p className='resource-description'>Upload Files<br />
                    <a className='resource-link' href='https://verifyle.com/@jaychangcpa' target='_blank' rel="noreferrer">https://verifyle.com/@jaychangcpa</a></p>
                </div>
            </div>
            <div>
                <h2 className="regional-title lato-font">Federal Links</h2>
                <div>
                    <div className='resource-grid lato-font'>
                        <div className='item1-resource margin-bot-0'>
                            <p className='resource-description'>Internal Revenue Service<br />
                            <a className='resource-link' href='https://www.irs.gov/' target='_blank' rel="noreferrer">https://www.irs.gov/</a></p>
                        </div>
                        <div className='item1-resource'>
                            <p className='resource-description'>Social Security<br />
                            <a className='resource-link' href='https://www.ssa.gov/' target='_blank' rel="noreferrer">https://www.ssa.gov/</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h2 className="regional-title lato-font">CA State Links</h2>
                <div className='resource-grid lato-font'>
                    <div className='item1-resource margin-bot-0'>
                        <p className='resource-description'>California Department of Labor<br />
                        <a className='resource-link' href='https://www.labor.ca.gov/' target='_blank' rel="noreferrer">https://www.labor.ca.gov/</a></p>
                    </div>
                    <div className='item1-resource'>
                        <p className='resource-description'>California Employment Development Department<br />
                        <a className='resource-link' href='https://edd.ca.gov/' target='_blank' rel="noreferrer">https://edd.ca.gov/</a></p>
                    </div>
                </div>
                <div className='resource-grid lato-font'>
                <div className='item1-resource margin-bot-0'>
                        <p className='resource-description'>California Department of Tax and Fee Administration<br />
                        <a className='resource-link' href='https://www.cdtfa.ca.gov/' target='_blank' rel="noreferrer">https://www.cdtfa.ca.gov/</a></p>
                    </div>
                    <div className='item1-resource'>
                        <p className='resource-description'>California Secretary of State<br />
                        <a className='resource-link' href='https://www.sos.ca.gov/' target='_blank' rel="noreferrer">https://www.sos.ca.gov/</a></p>
                    </div>
                </div>
                <div className='resource-grid lato-font'>
                    <div className='item1-resource margin-bot-0'>
                        <p className='resource-description'>California Franchise Tax Board<br />
                        <a className='resource-link' href='https://www.ftb.ca.gov/' target='_blank' rel="noreferrer">https://www.ftb.ca.gov/</a></p>
                    </div>
                    <div className='item1-resource'>
                        <p className='resource-description'>County of Los Angeles<br />
                        <a className='resource-link' href='https://lacounty.gov/' target='_blank' rel="noreferrer">https://lacounty.gov/</a></p>
                    </div>
                </div>
            </div>
            <div>
                <h2 className="regional-title lato-font">NV State Links</h2>
                <div className='resource-grid lato-font'>
                    <div className='item1-resource margin-bot-0'>
                        <p className='resource-description'>Nevada Department of Taxation<br />
                        <a className='resource-link' href='https://tax.nv.gov/' target='_blank' rel="noreferrer">https://tax.nv.gov/</a></p>
                    </div>
                    <div className='item1-resource'>
                        <p className='resource-description'>Nevada Secretary of State<br />
                        <a className='resource-link' href='https://www.nvsos.gov/sos' target='_blank' rel="noreferrer">https://www.nvsos.gov/sos</a></p>
                    </div>
                </div>
            </div>

            </div>
        </div>
        </>
    );
}
